// source: exTradeInfo.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.ExTradeInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExTradeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExTradeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExTradeInfo.displayName = 'proto.common.model.ExTradeInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExTradeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExTradeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExTradeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExTradeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
tradeid: jspb.Message.getFieldWithDefault(msg, 2, ""),
tradeintid: jspb.Message.getFieldWithDefault(msg, 3, 0),
orderid: jspb.Message.getFieldWithDefault(msg, 4, ""),
orderintid: jspb.Message.getFieldWithDefault(msg, 5, 0),
counterorderid: jspb.Message.getFieldWithDefault(msg, 6, ""),
side: jspb.Message.getFieldWithDefault(msg, 7, ""),
forcetaker: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
liquidity: jspb.Message.getFieldWithDefault(msg, 9, ""),
price: jspb.Message.getFieldWithDefault(msg, 10, ""),
size: jspb.Message.getFieldWithDefault(msg, 11, ""),
funds: jspb.Message.getFieldWithDefault(msg, 12, ""),
fee: jspb.Message.getFieldWithDefault(msg, 13, ""),
feerate: jspb.Message.getFieldWithDefault(msg, 14, ""),
feecurrency: jspb.Message.getFieldWithDefault(msg, 15, ""),
stop: jspb.Message.getFieldWithDefault(msg, 16, ""),
type: jspb.Message.getFieldWithDefault(msg, 17, ""),
createdat: jspb.Message.getFieldWithDefault(msg, 18, 0),
tradetype: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExTradeInfo}
 */
proto.common.model.ExTradeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExTradeInfo;
  return proto.common.model.ExTradeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExTradeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExTradeInfo}
 */
proto.common.model.ExTradeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradeid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTradeintid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderintid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCounterorderid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForcetaker(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiquidity(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSize(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunds(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setFee(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeerate(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeecurrency(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStop(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedat(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradetype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExTradeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExTradeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExTradeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExTradeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTradeid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradeintid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrderintid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCounterorderid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getForcetaker();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getLiquidity();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSize();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFunds();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getFee();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getFeerate();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getFeecurrency();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStop();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCreatedat();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getTradetype();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tradeId = 2;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getTradeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setTradeid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 tradeIntId = 3;
 * @return {number}
 */
proto.common.model.ExTradeInfo.prototype.getTradeintid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setTradeintid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string orderId = 4;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 orderIntId = 5;
 * @return {number}
 */
proto.common.model.ExTradeInfo.prototype.getOrderintid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setOrderintid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string counterOrderId = 6;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getCounterorderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setCounterorderid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string side = 7;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool forceTaker = 8;
 * @return {boolean}
 */
proto.common.model.ExTradeInfo.prototype.getForcetaker = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setForcetaker = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string liquidity = 9;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getLiquidity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setLiquidity = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string price = 10;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string size = 11;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setSize = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string funds = 12;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getFunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setFunds = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string fee = 13;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setFee = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string feeRate = 14;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getFeerate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setFeerate = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string feeCurrency = 15;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getFeecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setFeecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string stop = 16;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getStop = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setStop = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string type = 17;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int64 createdAt = 18;
 * @return {number}
 */
proto.common.model.ExTradeInfo.prototype.getCreatedat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string tradeType = 19;
 * @return {string}
 */
proto.common.model.ExTradeInfo.prototype.getTradetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExTradeInfo} returns this
 */
proto.common.model.ExTradeInfo.prototype.setTradetype = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


goog.object.extend(exports, proto.common.model);
